import Vue, {VueConstructor} from 'vue'

type ScriptCodeInjector = (id: string, code: string, option?: {
  src?: string,
  async?: boolean,
}) => Promise<HTMLScriptElement>;

interface VueWithScriptCodeInjector extends VueConstructor<Vue> {
  scriptCodeInjector: ScriptCodeInjector
}

const ScriptCodeInjector = {
  install: function (Vue: VueWithScriptCodeInjector) {
    /**
     * src/index.pug <head> 태그 내부에 script code를 삽입함
     * @param id
     * @param code
     * @param option
     * Return promise
     * @example
     * Vue.scriptCodeInjector('test-id', 'console.log("test-append-script-code")', {...})
     *  .then(() => {})
     *  .catch(() => {})
     */
    Vue.scriptCodeInjector = function (id, code, option) {
      return new Promise(function (resolve, reject) {
        let shouldAppend = false
        let el = document.querySelector('script[id="' + id + '"]') as HTMLScriptElement
        if(!el) {
          el = document.createElement('script')
          el.type = 'text/javascript'
          el.async = option?.async ?? true
          el.id = id
          el.text = code
          if(option?.src) el.src = option.src
          shouldAppend = true
        }
        else if(el.hasAttribute('data-loaded')) {
          resolve(el)
          return
        }

        el.addEventListener('error', reject)
        el.addEventListener('abort', reject)
        el.addEventListener('load', function loadScriptHandler() {
          el.setAttribute('data-loaded', 'true')
          resolve(el)
        })

        if(shouldAppend) document.head.appendChild(el)
      })
    }
  },
}

export default ScriptCodeInjector
